import React from 'react';
import Modal from 'react-modal';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Wrapper = styled.div`
  background: white;
  height: 80vh;
  overflow: auto;
  padding: 20px;

  .center {
    text-align: center;
  }

  a {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 23px;
    color: ${({ theme }) => theme.colors.french};

    .text {
      border-bottom: 2px solid #2a5caf;
    }

    &:hover {
      text-decoration: none;
    }
  }

  table {
    max-width: 590px;
  }

  @media (max-width: 992px) {
    padding: 10px;

    table {
      background: ${({ theme }) => theme.colors.oatmilk};
      border: none !important;
    }

    th {
      font-family: ${({ theme }) => theme.fonts.primary};
      font-style: normal;
      font-weight: ${({ theme }) => theme.old ? 'bold' : 600};
      font-size: 13px;
      line-height: 16px;
      letter-spacing: 0.02em;

      color: ${({ theme }) => theme.colors.charcoal};
    }

    td {
      font-family: ${({ theme }) => theme.fonts.primary};
      font-style: normal;
      font-weight: normal;
      font-size: 13px;
      line-height: 30px;
      padding: 10px 0;
    }

    .price {
      padding: 10px 0 10px 10px;
    }

    .order-total {
      width: 130px;
    }
  }
`;

function ShippingInformationModal({ open, toggle }) {
  return (
    <Modal
      className="ShippingInfoPdp"
      overlayClassName="ModalUfcOverlay"
      ariaHideApp={false}
      closeTimeoutMS={500}
      isOpen={open}
      onRequestClose={toggle}
    >
      <Wrapper>
        <CrossBar>
          <CloseIcon onClick={toggle} />
        </CrossBar>
        <br className="hide-on-mobile" />
        <br />
        <Title>Shipping Information</Title>

        <Text>
          For all products (with the exception of sofas and sectionals), we
          charge shipping based upon the order total. Shipping for sofas and
          sectional is charged on a per item basis and includes white glove
          delivery. With our premium White Glove Delivery, you’ll receive a call
          from our carrier to schedule delivery at a time that’s convenient for
          you. The delivery team will unwrap your piece, place it in the room of
          your choice, and discard any debris.
          <br />
          <br />
          See additional details below:
        </Text>

        <table className="table table-bordered  mt-3">
          <thead>
            <tr>
              <th className="order-total" scope="col">
                Order Total
              </th>
              <th className="center" scope="col">
                Shipping Charge
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="price">Up to $39</td>
              <td className="center">$6.95</td>
            </tr>
            <tr>
              <td className="price">$39.01 - $49</td>
              <td className="center">$7.95</td>
            </tr>
            <tr>
              <td className="price">$49.01 - $65</td>
              <td className="center">$9.95</td>
            </tr>
            <tr>
              <td className="price">$65.01 - $80</td>
              <td className="center">$11.95</td>
            </tr>
            <tr>
              <td className="price">$80.01 - $99</td>
              <td className="center">$13.95</td>
            </tr>
            <tr>
              <td className="price">$99.01 - $200</td>
              <td className="center">$18.95</td>
            </tr>
            <tr>
              <td className="price">Over $200</td>
              <td className="center">10% of order</td>
            </tr>
            <tr>
              <td colSpan="3">
                <p className="font-italic mb-0">
                  *Shipping rates are based on product totals before any
                  promotion is applied.
                </p>
              </td>
            </tr>
            <tr>
              <td colSpan="3">
                <p className="font-italic mb-0">
                  **Accent chairs will incur a flat rate charge of $99.
                </p>
              </td>
            </tr>
            <tr>
              <td colSpan="3">
                <p className="font-italic mb-0">
                  ***Dining chairs will incur shipping charge of 15% for
                  unassembled & 20% for assembled delivery.
                </p>
              </td>
            </tr>
            <tr>
              <td colSpan="3">
                <p className="font-italic mb-0">
                  ****A fee of $15 may be charged to orders containing oversized
                  products.
                </p>
              </td>
            </tr>
            <tr>
              <td colSpan="3">
                <p className="font-italic mb-0">
                  ***** An additional shipping fee per product will be charged
                  for items shipping to Alaska or Hawaii, which will be updated
                  in your shopping cart.
                </p>
              </td>
            </tr>
            <tr>
              <td className="text-center" colSpan="3">
                <strong>White Glove Delivery</strong>
              </td>
            </tr>
            <tr>
              <td className="price">Sofa</td>
              <td className="center">$249</td>
            </tr>
            <tr>
              <td className="price">Sectional</td>
              <td className="center">$269</td>
            </tr>
          </tbody>
        </table>
        <br />

        <Title>Our Return Policy</Title>

        <Text>
          <p>
            We hope you absolutely LOVE your piece. But if for any reason you
            are not satisfied with the product when it arrives, we accept
            returns within 30 days of delivery (less the cost of shipping).
            We’re proud of our partners and we love our products -- and we hope
            you do too.
          </p>
          <p>
            We will refund your original form of payment; refunds are usually
            processed within 2-3 days. Wherever possible, please use the
            original packaging.
          </p>
          <p>
            Note: Peel and stick wallpaper is only returnable if it is unopened.
          </p>
        </Text>
        <br />
        <br />
        <Title>Order cancellation and modification policy</Title>

        <Text>
          After an order is placed, we are unable to accept cancellations or
          modifications. Here’s why:
          <br /> <br />
          Each item from The Inside is custom made just for you. When you submit
          your order, our system immediately starts production with our
          manufacturers across North America. This process allows us to deliver
          on our mission to grant access to more design for more value. In order
          to uphold our promise on price and speed, we cannot accommodate
          cancellations or modifications. If for any reason you are not
          satisfied with the product when it arrives, we accept returns within
          30 days (less the cost of shipping). We’re proud of our partners and
          we love our products -- and we hope you do too.
          <br /> <br />
          We realize mistakes happen and changes are inevitable, so if you need
          to make an adjustment within 24 hours of placing your order, please
          reach out to{' '}
          <a className="link" href="mailto:hi@theinside.com">
            hi@theinside.com
          </a>{' '}
          . Our customer care team will do its best to accommodate but cannot
          guarantee changes. After 24 hours, we are unable to cancel or modify
          your order in any way.
        </Text>
        <br />
        <Link to="/our-guarantee">
          <span className="text">Our guarantee</span> {'>'}
        </Link>
        <br />
        <br />
      </Wrapper>
    </Modal>
  );
}

export default ShippingInformationModal;

const CrossBar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 50px;
  background: white;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  svg {
    margin-right: 20px;
  }

  @media (max-width: 992px) {
    height: 30px;
  }
`;

const Title = styled.div`
  margin-bottom: 24px;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: ${({ theme }) => theme.old ? 'bold' : 600};
  font-size: 15px;
  line-height: 18px;
  /* identical to box height */

  letter-spacing: 0.12em;
  text-transform: uppercase;

  color: ${({ theme }) => theme.colors.charcoal};
`;

const Text = styled.div`
  /* Body 3 / Regular */

  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 23px;
  /* or 144% */

  color: ${({ theme }) => theme.colors.charcoal};
`;

const BoldText = styled.div`
  /* Body 3 / Bold */

  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: ${({ theme }) => theme.old ? 'bold' : 600};
  font-size: 16px;
  line-height: 23px;
  /* identical to box height, or 144% */

  color: ${({ theme }) => theme.colors.charcoal};
`;

const CloseIconWrapper = styled.svg`
  cursor: pointer;
`;
function CloseIcon({ onClick }) {
  return (
    <CloseIconWrapper
      onClick={onClick}
      width="14"
      height="14"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 2L18.9706 18.9706"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        d="M19 2L2.02944 18.9706"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </CloseIconWrapper>
  );
}
